import { ItemGroupSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useInventoryItemGroupsQuery = createQueryHook(
  'inventory.itemGroups',
  (params: {
    searchTerm?: string;
    sorting?: ItemGroupSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    itemGroups: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.itemGroups.entries.map((itemGroup) => ({
        id: itemGroup.id,
        name: itemGroup.name,
      })) ?? [],
  },
);
